import Page from "../common/page";
import MotionKvVideo from "../lib/motion-kv-video";
import {CustomEventHandler} from "../utils/CustomEventHandler";
import {scrollSetting} from "../common/globalVars";
import MotionStickyResize from "../lib/motion-sticky-resize";
import MotionScrollBox from "../lib/motion-scroll-box";

export default class PageTechnology extends Page {
   setPage() {
      this.posBoxEl = this.el.querySelector('.sec-1 .pos-box');
      new MotionStickyResize(
          this.el.querySelector('.sec-1'),
          this.el.querySelector('.sec-3')
      )
      new MotionKvVideo(
          this.el.querySelector('.sec-1'),
          this.el.querySelector('.line-1'),
          0,0, 0
      );
      new MotionKvVideo(
          this.el.querySelector('.sec-1'),
          this.el.querySelector('.video-1'),
          30,0, 2
      );
      new MotionScrollBox(
          this.el.querySelector('.sec-1'),
          this.el.querySelector('.sec-1 .pos-box'),
           0.5
      )

      this.sec6TxtBox = [
         this.el.querySelector('.sec-6 .txt-box-1'),
         this.el.querySelector('.sec-6 .txt-box-2'),
         this.el.querySelector('.sec-6 .txt-box-3'),
      ]

      this.el.querySelector('.sec-1 .col-page-title').style.position = 'relative';
      this.el.querySelector('.sec-1 .col-page-title').style.top = `0`;

      if (!scrollSetting.smooth) {
         this.setSticky();
      }

      CustomEventHandler.addHandler(this.el.querySelector('.sec-6 video'), 'timeupdate', (e)=>this.onVideoTimeUpdateHandler(e));

      this.onResizeHandler();
      CustomEventHandler.addHandler(window, 'resize', ()=>this.onResizeHandler());
   }

   onVideoTimeUpdateHandler(e) {
      let currentTime = e.target.currentTime;
      let currentTxt;

      if (currentTime < 3) {
         currentTxt = 0;
      } else if (currentTime < 6) {
         currentTxt = 1;
      } else {
         currentTxt = 2;
      }

      for (let i=0;i<this.sec6TxtBox.length; i++) {
         this.sec6TxtBox[i].classList.remove('onShow');
         if (i===currentTxt) {
            this.sec6TxtBox[i].classList.add('onShow');
         }
      }
   }


   setSticky() {
      this.stickyEl = this.el.querySelector('.sticky-holder');
      this.stickyEl.style.position = 'sticky';
      this.stickyEl.parentNode.style.height = '100%';

      this.posBoxEl.style.position = 'sticky';
   }

   onResizeHandler() {
      if (!scrollSetting.smooth) {
         this.posBoxEl.style.top = `${window.innerHeight / 2 - parseFloat(window.getComputedStyle(this.posBoxEl).height) / 2}px`;
      }
      this.el.querySelector('.sec-1 .page-title').style.paddingBottom = `${window.innerHeight/10}px`;
   }
}
